import {
  FormValidation,
  creditCardExpirationValidate,
  creditCardNumberValidate,
  emailValidate,
  nameValidate,
  cvvNumberValidate,
} from '@data/other/validation';

export default class CreditCard {
  'credit-card': string;
  'expiration-date': string;
  'cvc': string;
  'cardholder': string;
  'billing-email': string;
  'address': string;
  'apt-suite-floor-etc': string;
  'country': string;
  'state': string;
  'city': string;
  'zip-code': string;

  constructor(data?: Dict) {
    Object.assign(this, data);
    // remove non-numeric characters from credit card number
    this['credit-card'] = (data?.['credit-card'] || '').replace(/[^0-9]/g, '');
  }

  public static validationModel: FormValidation<CreditCard> = {
    'credit-card': { required: true, validate: creditCardNumberValidate },
    'expiration-date': {
      required: true,
      validate: creditCardExpirationValidate,
    },
    cardholder: { required: true, maxLength: 45, validate: nameValidate },
    cvc: { required: true, validate: cvvNumberValidate },
    address: { maxLength: 95 },
    'apt-suite-floor-etc': { maxLength: 95 },
    city: { maxLength: 35 },
    'zip-code': { maxLength: 12 },
    'billing-email': { required: true, maxLength: 60, validate: emailValidate },
  };
}
